import {IDeviceNode, NumberSensorInputMap} from '../../shared/models/device';
import {ICardDataViewModel} from '../../shared/models/models';

export class CardData implements ICardDataViewModel {
    public data: IDeviceNode;
    public name;
    public value = '';
    public isCategory = false;
    public isVisible = true;
    public sensorId?: number;
    public isEnabled?: boolean;
    public numberSensorInputMap?: NumberSensorInputMap;
    public order?: number;
    public valueSet?: number[];
    public indent: number;
    public hidableKeys: string[];
    public categories: string[];

    constructor(
        _data: IDeviceNode,
        _displayValue: string,
        _numberSensorInputMap?: NumberSensorInputMap,
        _indent?: number,
        _hidableKeys?: string[],
        _categories?: string[]
    ) {
        this.data = _data;
        this.value = _displayValue;
        this.name = _data.displayText;
        this.isVisible = _data.isVisible;
        this.sensorId = _data.sensorId;
        this.isEnabled = _data.isEnabled;
        this.numberSensorInputMap = _numberSensorInputMap;
        this.order = _data.order;
        this.valueSet = _data.valueSet;
        this.indent = _indent;
        this.hidableKeys = _hidableKeys;
        this.categories = _categories;
    }
}
